import { Link, Typography } from "@mui/material"
import Markdown from "react-markdown";
import { useRules } from "../hooks/useRules";
import '../markdown-styles.css'; 
import DOMPurify from 'dompurify';

const RulesPage = () => {
  const { rules, loading, error } = useRules();
  const dirtyHTML = rules.rulesText;
  const cleanHTML = DOMPurify.sanitize(dirtyHTML);
  return (
    <>
      <Typography variant="h1">{rules.title}</Typography>
      <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
    </>
  )
}

export default RulesPage
